import React, { Component } from 'react';
import { Row, Cell } from './tableUtils';
import css from './usersTable.scss';
import Popup from '../popup/popup';
import { Mutation } from 'react-apollo';
import { CREATE_USER, GET_USERS } from './queries';

class CreateUser extends Component {
	state = {
		client_name: '',
		client_address: '',
		contact_firstname: '',
		contact_lastname: '',
		email: '',
		fonction: '',
		telephone: '',
	};
	updateState = e => {
		let state = {};
		state[e.target.name] = e.target.value;
		this.setState(_ => state);
	};
	updateCache = (cache, { data: { user } }) => {
		const data = cache.readQuery({ query: GET_USERS });
		data.users.push(user);
		cache.writeQuery({ query: GET_USERS, data });
		this.setState(_ => ({
			client_name: '',
			client_address: '',
			contact_firstname: '',
			contact_lastname: '',
			email: '',
			fonction: '',
			telephone: '',
		}));
	};
	render() {
		return (
			<Mutation
				mutation={CREATE_USER}
				variables={this.state}
				update={this.updateCache}
			>
				{(addUser, { loading, error }) => (
					<form
						className={css.form + (loading ? ' loading' : '')}
						onSubmit={e => {
							e.preventDefault();
							addUser();
						}}
					>
						<Row>
							<Cell type="deleteCol">
								<button className={css.confirm} type="submit" />
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Nom du Client"
									name="client_name"
									onChange={this.updateState}
									value={this.state.client_name}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Adresse du Client"
									name="client_address"
									onChange={this.updateState}
									value={this.state.client_address}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Prenom du Contact"
									name="contact_firstname"
									onChange={this.updateState}
									value={this.state.contact_firstname}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Nom du Contact"
									name="contact_lastname"
									onChange={this.updateState}
									value={this.state.contact_lastname}
								/>
							</Cell>
							<Cell>
								<input
									type="text"
									placeholder="Fonction"
									name="fonction"
									onChange={this.updateState}
									value={this.state.fonction}
								/>
							</Cell>
							<Cell>
								<input
									type="tel"
									placeholder="Téléphone"
									name="telephone"
									onChange={this.updateState}
									value={this.state.telephone}
								/>
							</Cell>
							<Cell type="email">
								<input
									type="email"
									placeholder="Email"
									name="email"
									onChange={this.updateState}
									value={this.state.email.toLowerCase()}
								/>
							</Cell>
							<Cell />
							{error && (
								<Popup opened>
									{error.graphQLErrors[0]
										? error.graphQLErrors[0].message
										: 'Unknown Error'}
								</Popup>
							)}
						</Row>
						<input type="submit" className={css.hidden} />
					</form>
				)}
			</Mutation>
		);
	}
}

export default CreateUser;



// WEBPACK FOOTER //
// ./src/components/usersTable/createUser.js